export default __webpack_public_path__ + "static/rabbit-f62258d7a675f0ff0b1cf620993432e3.gif";